import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';


import { api_host, api_auth } from '../../../../../common/globals/constants';

import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment'
import 'moment/locale/es'  
moment.locale('es')

class AvailabilityDowntimeGlobal extends Component {

    constructor(props) {
        super(props);
        // console.log("componente down=> ",props)
        var step=null
        var periodical=false
        if(props.params.periodical===true){
            step=this.props.indexStep
            periodical=true
        }
        var periodicalView = props.params.periodicalView
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            step: step,
            hoverData: null,
            lastEvent: [],
            periodical:periodical,
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            rows: null,
            noMonCum: null,
            downCum: null,
            date: this.props.params.date,
            dateMoment: ((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")),
            isRefresh: this.props.params.isRefresh,
            nameStep:this.props.params.nameStep,
            periodicalView : periodicalView
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (props.match.params.objetivo_id !== state.prevObjectiveId) {
            return {
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
            }
        } else if (props.params.period !== state.time) {
            return {
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if (props.params.step !== state.step) {
            return {
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: state.time,
                step: props.params.step,
                lastEvent: [],
                dataError: false,
                isLoading: true,
                hoverData: null,
                statePeriod: props.params.statePeriod,
                nameStep:props.params.nameStep
            }
        } else if(props.params.isRefresh !== state.isRefresh){
            return {
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isRefresh: props.params.isRefresh,          
            }

        } else if ((props.params.period === state.time) && (props.params.statePeriod !== state.statePeriod)) {
            return {
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        }
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }

        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.step !== this.state.step) ||
            (prevProps.params.isRefresh !== this.state.isRefresh) ||
            (prevProps.params.statePeriod !== this.state.statePeriod)) {
            this.getDataFromAPI();
        }

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod, node, step, isStepDowntime } = this.props.params
        const { history } = this.props;
        
        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        let time = 'w'
        let stepLocal = step
        if (this.state.period !== 'w') {
            time = 'd'
        }
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            fetch(api_host + `/reporte/online/indicadores/getDetalleDisponibilidadGlobalPasoDowntimeCustom/?objetivoId=${objetivo_id}&horarioId=0&token=${token}&key=${api_auth}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&nodoId=${node}&pasoId=${stepLocal}`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                step,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent !== []) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                });
        } else {
            fetch(api_host + `/reporte/online/indicadores/getDetalleDisponibilidadGlobalPasoDowntime/?objetivoId=${objetivo_id}&horarioId=0&token=${token}&key=${api_auth}&t=${period}&nodoId=${node}&pasoId=${stepLocal}`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                step,
                                period,
                                fecha_inicio,
                                fecha_termino)
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                });

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        step,
        period,
        fecha_inicio,
        fecha_termino) => {

   
        let rowLen = externalData.Objetivo.Paso.length
        let fecha_desde = null
        let fecha_hasta = null
        
        let duration = null
        let durationDate = null
        let arrayRows = []
        let noMonCum = 0
        let downCum = 0
        let noMonCumDate = null
        let downCumDate = null
       
        let estado = externalData.Objetivo.Paso[0].estado

        if (estado.length > 0) {
            Object.keys(estado).map((key)=> {
                let rows = {}
            
                fecha_desde = new Date(estado[key]['fecha_desde'])
                fecha_hasta = new Date(estado[key]['fecha_hasta'])
                rows['fecha'] = estado[key]['fecha_desde'].substring(0, 10)
                rows['hora_inicio'] = estado[key]['fecha_desde'].substring(11, 19)
                rows['hora_termino'] = estado[key]['fecha_hasta'].substring(11, 19)
                duration = (fecha_hasta.getTime() - fecha_desde.getTime()) / 1000
                durationDate = new Date(duration * 1000).toISOString().substr(11, 8)
                rows['duracion'] = durationDate
                rows['nombre'] = estado[key]['nombre']
                arrayRows.push(rows)

                if (estado[key]['nombre'] == "no monitoreo") {
                    noMonCum = noMonCum + duration
                } else if (estado[key]['nombre']== "downtime") {
                    downCum = downCum + duration
                }

            })

            var leftover = noMonCum;
            var days = Math.floor(leftover / 86400);

            if (days > 0) {
                noMonCumDate = days + ' dia(s) ' + new Date(noMonCum * 1000).toISOString().substr(11, 8)
            } else {
                noMonCumDate = new Date(noMonCum * 1000).toISOString().substr(11, 8)
            }

            var leftoverDown = downCum;
            var daysDown = Math.floor(leftoverDown / 86400);

            if (daysDown > 0) {
                downCumDate = daysDown + ' dia(s) ' + new Date(downCum * 1000).toISOString().substr(11, 8)
            } else {
                downCumDate = new Date(downCum * 1000).toISOString().substr(11, 8)
            }


            this.setState({
                rows : arrayRows,
                noMonCum : noMonCumDate,
                downCum : downCumDate,
                isLoading: false,
                time: period,
                step: step,
                dataError: false,
            });
        } else {
            this.setState({
                noMonCum : 0,
                downCum : 0,
                isLoading: false,
                rows: null,
                time: period,
                step: step,
                dataError: false,
            });
        }
    

    }
    render() {
        const { dataError, isLoading, rows, noMonCum, downCum , periodical, step, nameStep,periodicalView} = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };
  
        if (!dataError) {

            return (<FormattedChart rows={rows} noMonCum={noMonCum} downCum={downCum} isLoading={isLoading} 
                style={style} styleHidden={styleHidden} periodical={periodical} step={step} nameStep={nameStep}
                periodicalView ={periodicalView}/>) 
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p> Error!</p >)

    }
}

function rowTitle(props){
    var title="Disponibilidad Downtime Global Por Paso "+props.nameStep
    return <TableRow>
        <TableCell colSpan={5}>{title}</TableCell>
    </TableRow>
}

function createSingleTable(props, styleTable){
    var step=props.step
    sessionStorage.setItem("AvailabilitytableDownStep"+step, 1)
    var id="AvailabilitytableDownStep_"+step+"_0"
    // TABLA GRAFICOS ONLINE
    sessionStorage.setItem("AvailabilityDowntimeTables",JSON.stringify(({'header':[{'fecha':"Fecha Inicio"},{'hora_inicio':"Hora Inicio"},
                                                                        {'hora_termino':"Hora Termino"},{'duracion':"Duración"},{'nombre':"Tipo"}],
                                                                        'data':props.rows,'title':'Disponibilidad Downtime Global Por Paso',
                                                                        'dynamic':[{'nombre':'Downtime Acumulado','colSpan':3,'value':props.downCum},
                                                                        {'nombre':'No monitoreo Acumulado','colSpan':3,'value':props.noMonCum}]})))

    
    //console.log(id)
    var table=<Table id={id} style={styleTable} aria-label="spanning table" >
                <TableHead>
                    {props.periodical?rowTitle(props):null}
                    <TableRow>
                        {/* TABLA ONLINE POR PASO */}
                        <TableCell>Fecha Inicio</TableCell> 
                        <TableCell>Hora Inicio</TableCell>
                        <TableCell>Hora termino</TableCell>
                        <TableCell>Duración</TableCell>
                        <TableCell>Tipo</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.rows.map(row => (
                        <TableRow >
                            <TableCell>{row.fecha}</TableCell>
                            <TableCell>{row.hora_inicio}</TableCell>
                            <TableCell>{row.hora_termino}</TableCell>
                            <TableCell>{row.duracion}</TableCell>
                            <TableCell>{row.nombre}</TableCell>
                        </TableRow>
                    ))}
                    <TableRow>
                        <TableCell rowSpan={3} />
                        <TableCell colSpan={3}>Downtime Acumulado</TableCell>
                        <TableCell>{props.downCum}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={3}>No monitoreo Acumulado</TableCell>
                        <TableCell>{props.noMonCum}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
    return table

}

function createMultiplesTables(props, styleTable){
    var step=props.step
    var i,j, temporary, chunk = 9;
    var cont=0
    var Tables=[]
    var periodical=props.periodical
    for (i = 0,j = props.rows.length; i < j; i += chunk) {
        var temporary = props.rows.slice(i, i + chunk);
        var sessionContTable=parseInt(sessionStorage.getItem("AvailabilitytableDownStep"+step))
        var tBody=<TableBody>
                    {temporary.map(row=>(
                        <TableRow >
                            {/* {periodical?rowTitle(props):null} */}
                            <TableCell>{row.fecha}</TableCell>
                            <TableCell>{row.hora_inicio}</TableCell>
                            <TableCell>{row.hora_termino}</TableCell>
                            <TableCell>{row.duracion}</TableCell>
                            <TableCell>{row.nombre}</TableCell>
                        </TableRow>
                    ))}
                    {sessionContTable===cont+1?
                    <TableRow>
                        <TableCell />
                        <TableCell colSpan={3}>DownTime Acumulado</TableCell>
                        <TableCell>{props.downCum}</TableCell>
                    </TableRow>
                    :null}
                    {sessionContTable===cont+1?
                        <TableRow>
                            <TableCell />
                            <TableCell colSpan={3}>No monitoreo Acumulado</TableCell>
                            <TableCell>{props.noMonCum}</TableCell>
                        </TableRow>
                    :null}
                </TableBody>
        
        var id="AvailabilitytableDownStep_"+step+"_"+cont
        var table =<Table style={styleTable} id={id} aria-label="spanning table" >
                    <TableHead >
                        <TableRow style={{textAlign:"center"}}>
                            <TableCell colSpan={5}>{props.name}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Fecha Inicio</TableCell>
                            <TableCell>Hora Inicio</TableCell>
                            <TableCell>Hora termino</TableCell>
                            <TableCell>Duración</TableCell>
                            <TableCell>Tipo</TableCell>
                        </TableRow>
                    </TableHead>
                    {tBody}
                    </Table>
        Tables.push(table)
        cont++
    }
    sessionStorage.setItem("AvailabilitytableDownStep"+step, cont)
    return Tables

}

function createTable(props){
    var styleTable={}
    if(props.periodical!==true){
        return createSingleTable(props, styleTable)
    }else if( props.periodicalView == true){
        return createSingleTable(props, styleTable)
    }
    else{
        styleTable={border:"1px solid black"}
        if(props.rows.length<=9){
            return createSingleTable(props, styleTable)
        }else{
            return createMultiplesTables(props, styleTable)
        }
    }
}

function FormattedChart(props) {

    if (props.rows == null) {
        sessionStorage.setItem("AvailabilityDowntimeTables",JSON.stringify(({'header':[{'fecha':"Fecha Inicio"},{'hora_inicio':"Hora Inicio"},
                                                                        {'hora_termino':"Hora Termino"},{'duracion':"Duración"},{'nombre':"Tipo"}],
                                                                        'data':[{fecha:'Sin Caidas Globales'}],'title':'Disponibilidad Downtime Global Por Paso'})))

    }
    return (
        <div >
            <div style={props.styleHidden}>
            <PortletContent>
                <PerfectScrollbar>

                    <Typography
                      variant="h5"
                    >
                     <CircularProgress
                      variant="indeterminate"

                      size={24}
                      thickness={4}
                      
                    />
                    <br/>
                     Cargando Información...
                   </Typography>
                  </PerfectScrollbar>
            </PortletContent>
            </div>
            <div style={props.style}>
                { props.rows == null  ? 

                    
                    <Table  aria-label="spanning table" >
                    <TableHead >
                        <TableRow>
                            <TableCell>Fecha Inicio</TableCell>
                            <TableCell>Hora Inicio</TableCell>
                            <TableCell>Hora termino</TableCell>
                            <TableCell>Duración</TableCell>
                            <TableCell>Tipo</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell rowSpan={3} />
                            <TableCell colSpan={3}>Sin Caidas Globales</TableCell>
                                                        
                        </TableRow>
                        
                        <TableRow>
                            <TableCell rowSpan={3} />
                            <TableCell colSpan={3}>Downtime Acumulado</TableCell>
                            
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={3}>No monitoreo Acumulado</TableCell>
                        </TableRow>
                    </TableBody>
                    </Table>
                    
                   
                : createTable(props)  }
            </div>
        </div>
        )

}


export default withRouter(AvailabilityDowntimeGlobal);